import { timesIcon } from "../../elements/icons/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Display a message in a colored box with a border. If `dismissible`
 * is truthy, the box can be closed.
 *
 * @param {Renderable} [title] - Will be rendered first in the box within a <strong> markup.
 * @param {Renderable} content - Main body of the box.
 * @param {boolean} [dismissible] - When true, a cross × is displayed to let the user close the message.
 * @param {"success"|"info"|"warning"|"danger"} [type] - The type is used to decide on the color of the box.
 * @param {string} [dataTestName] - The string used to find the message within the test framework.
 */
export default class AlertMessageWidget extends Widget {
	constructor({
		title = "",
		content,
		dismissible = true,
		type = "info",
		dataTestName = "alert-message",
	}) {
		super(...arguments);

		this._title = title;
		this._content = content;
		this._dismissible = dismissible;
		this._type = type;
		this._dataTestName = dataTestName;
	}

	renderContentOn(html) {
		html.div(
			{
				class: [
					"alert",
					`alert-${this._type}`,
					{ "alert-dismissible": this._dismissible },
				],
				role: "alert",
				"data-test": this._dataTestName,
			},
			this._renderCloseButtonOn.bind(this),
			this._renderTitleOn.bind(this),
			" ",
			this._renderBodyOn.bind(this),
		);
	}

	_renderCloseButtonOn(html) {
		if (!this._dismissible) {
			return;
		}

		html.button(
			{
				type: "button",
				class: "close",
				"data-dismiss": "alert",
				"aria-label": "Close",
			},
			timesIcon,
		);
	}

	_renderTitleOn(html) {
		if (!this._title) {
			return;
		}
		html.strong(this._title);
	}

	_renderBodyOn(html) {
		html.span(this._content);
	}
}
